import React, { useEffect, useState } from "react";
import axios from "axios";
import L from "leaflet";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { PiBeerBottleFill } from "react-icons/pi";
import {
  GiPlasticDuck,
  GiSodaCan,
  GiRecycle,
  GiFlatTire,
} from "react-icons/gi";
import {
  FaWineBottle,
  FaTshirt,
  FaGlassMartiniAlt,
  FaPaperPlane,
  FaCar,
  FaOilCan,
} from "react-icons/fa";
import { IoMdBatteryCharging } from "react-icons/io";

import { useGetBinsQuery } from "../../setup/rtk-query/APIs/binApi";
import Loading from "../Loading/Loading";
import green from "../../assets/images/green-point.png";
import blue from "../../assets/images/blue-point.png";
import yellow from "../../assets/images/yellow-point.png";
import "./Map.scss";
import { Alert } from "react-bootstrap";
import { SyncLoader } from "react-spinners";

const Map = () => {
  const filterList = [
    {
      name: "All",
      icon: GiRecycle,
    },
    {
      name: "Plastic",
      icon: GiPlasticDuck,
    },
    {
      name: "Plastic bottels",
      icon: PiBeerBottleFill,
    },
    {
      name: "Glass",
      icon: FaGlassMartiniAlt,
    },
    {
      name: "Glass bottels",
      icon: FaWineBottle,
    },
    {
      name: "Paper",
      icon: FaPaperPlane,
    },
    {
      name: "Cans",
      icon: GiSodaCan,
    },
    {
      name: "Clothes",
      icon: FaTshirt,
    },
    {
      name: "Scrap metal",
      icon: FaCar,
    },
    {
      name: "Batteries",
      icon: IoMdBatteryCharging,
    },
    {
      name: "Tires",
      icon: GiFlatTire,
    },
    {
      name: "Engine oil",
      icon: FaOilCan,
    },
  ];
  const [active, setActive] = useState(["All"]);

  const { data, isLoading, isError, error } = useGetBinsQuery(
    active.includes("All") ? "" : `materials=${active.join(",")}`
  );

  const sampleCentersData = data?.data;

  const findClosestBin = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };

          // Calculate the distance to each bin and find the closest one
          const closestBin = sampleCentersData.reduce(
            (closest, bin) => {
              const binLocation = {
                latitude: bin.latitude,
                longitude: bin.longitude,
              };

              const distanceToUser = getDistance(userLocation, binLocation);

              if (distanceToUser < closest.distance) {
                return {
                  bin,
                  distance: distanceToUser,
                };
              }

              return closest;
            },
            { bin: null, distance: Infinity }
          );

          if (closestBin.bin) {
            // Open Google Maps with directions to the closest bin
            window.open(
              `https://www.google.com/maps/dir/${userLocation.latitude},${userLocation.longitude}/${closestBin.bin.latitude},${closestBin.bin.longitude}`
            );
          } else {
            console.error("No recycling bins found.");
          }
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            console.error("Permission denied to access user's location.");
          } else {
            console.error("Error getting current position:", error);
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by your browser");
    }
  };

  const getDistance = (location1, location2) => {
    const lat1 = location1.latitude;
    const lon1 = location1.longitude;
    const lat2 = location2.latitude;
    const lon2 = location2.longitude;

    const R = 6371; // Radius of the Earth in kilometers
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  const changeActive = (name) => {
    if (name === "All") {
      setActive(["All"]);
    } else {
      let arr = active.filter((name) => name !== "All");
      if (arr.includes(name)) arr = arr.filter((item) => item !== name);
      else arr.push(name);
      if (arr.length === 0) setActive(["All"]);
      else setActive(arr);
    }
  };

  const navigateToBin = (latitude, longitude) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          window.open(
            `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${latitude},${longitude}`
          );
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            // Handle permission denied error
            console.error("Permission denied to access user's location.");
          } else {
            console.error("Error getting current position:", error);
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by your browser");
    }
  };

  const [axiosError, setaxiosError] = useState("");
  const [isaxioserror, setisaxioserror] = useState(false);
  const [show, setShow] = useState(true);

  const [geoJsonData, setGeoJsonData] = useState(null);
  const center = [38.74, -9.15];

  const fetchFreguesias = async (municipio) => {
    const response = await axios.get(
      `https://geoapi.pt/municipio/${municipio}?json=1`
    );
    return response.data.geojsons.municipio;
  };
  const fetchData = async () => {
    try {
      if (!isLoading && !isError) {
        const lisboaData = await fetchFreguesias("lisboa");
        const combinedData = {
          type: "FeatureCollection",
          features: [lisboaData],
        };

        setGeoJsonData(combinedData);
      }
      setisaxioserror(false);
    } catch (error) {
      setaxiosError(error.message);
      setisaxioserror(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [isLoading, isError]);

  const greenIcon = new L.Icon({
    iconUrl: green, // Replace with the actual path to your marker image
    iconSize: [16, 16], // Set the width and height of the icon
  });

  const blueIcon = new L.Icon({
    iconUrl: blue, // Replace with the actual path to your marker image
    iconSize: [16, 16], // Set the width and height of the icon
  });

  const yellowIcon = new L.Icon({
    iconUrl: yellow, // Replace with the actual path to your marker image
    iconSize: [16, 16], // Set the width and height of the icon
  });

  return (
    <div className="map">
      {isaxioserror ? (
        <Alert variant="danger" onClose={() => setShow(false)} dismissible>
          {axiosError}
        </Alert>
      ) : (
        ""
      )}
      {isLoading ? (
        <SyncLoader className="text-center pb-5 mt-5 pt-5 m-auto" size={12}  color="#009f3b" />
      ) : isError ? (
        <Alert variant="danger" onClose={() => setShow(false)} dismissible>
          {error?.data?.error}
        </Alert>
      ) : (
        <>
          <div className="map-container">
            <MapContainer
              center={center}
              zoom={12}
              scrollWheelZoom={false}
              style={{ height: "500px", width: "100%" }}
            >
              <TileLayer
                    url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                    attribution='&copy; <a href="https://carto.com/">carto.com</a> contributors'
              />
              {geoJsonData && <GeoJSON data={geoJsonData} />}
              {sampleCentersData.map((center, i) => (
                <Marker
                  key={i}
                  icon={
                    center.materials.includes("Plastic")
                      ? greenIcon
                      : center.materials.includes("Glass")
                      ? blueIcon
                      : yellowIcon
                  }
                  position={[center.latitude, center.longitude]}
                >
                  <Popup>
                    <strong>{center.name}</strong>
                    <br />
                    Materials Accepted: {center.materials.join(", ")}
                    <br />
                    Address: {center.address}
                    <button
                      style={
                        center.materials.includes("Plastic")
                          ? { background: "#009f3b" }
                          : center.materials.includes("Glass")
                          ? { background: "#1640d6" }
                          : { background: "#f2a800" }
                      }
                      className="location-btn"
                      onClick={() =>
                        navigateToBin(center.latitude, center.longitude)
                      }
                    >
                      Take Me There
                    </button>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>

          <div className="filter">
            <div className="list">
              {filterList.map((itme) => (
                <div
                  className={`item ${
                    active.includes(itme.name) ? "active" : ""
                  }`}
                  onClick={() => changeActive(itme.name)}
                  key={itme.name}
                >
                  <span>{itme.name}</span>
                  <div className="icon">
                    <itme.icon />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button className="location-btn-v2" onClick={() => findClosestBin()}>
            Take Me To Closest One To Me
          </button>
        </>
      )}
    </div>
  );
};

export default Map;
